<template>
  <!-- v-if="pending !== 1" -->
  <div class="pending-wrapper">
    <div class="result-box" v-if="pending !== 1">
      <div class="process-box">
        <!-- <el-progress class="process-item" type="circle" :percentage="percent" :show-text="false"></el-progress>
      <img class="wallet" src="@/assets/images/wallet.png" width="60" /> -->
        <i class="el-icon-loading custom_loading"></i>
      </div>
      <!-- <div class="pending">
      <span>{{ $t('message.result.processing') }}</span>
      <span class="ellipsis">...</span>
    </div> -->
      <!-- :popupStatus="resultPopup.popupStatus" :popupTitle="resultPopup.popupTitle" :popupText="resultPopup.popupText" -->
    </div>
    <popupBottom :open="resultPopup.visible" v-bind="resultPopup">
    </popupBottom>
  </div>

</template>
<script>
import { getStatus, getBrandInfo } from '@/api/checkout';
import popupBottom from '@/components/popupBottom/index.vue';
import { deviceFingerprintManager } from '@/plugins/eventTrackManager/deviceFingerprintManager';
import { getCheckoutType, sendGaResultEvent } from '@/utils/tools/ga';
import { exceptionShow, showMessage } from '@/utils/tools/utils';

export default {
  components: {
    popupBottom,
  },
  data() {
    return {
      percent: 10,
      tryCount: 0,
      tryInterval: 1000,
      pending: 1,
      type: '',
      orderInfo: null,
      resultPopup: {
        visible: false,
        popupStatus: '',
        popupTitle: '',
        popupText: '',
        showReturnBtn: true,
        redirectUrl: '',
      },
    };
  },

  created() {
    this.type = getCheckoutType(this.$route.query.type, this.$route.query.key);
    getBrandInfo(this.$route.query.key).then((res) => {
      if (res.respCode === '20000' && res.data) {
        this.$store.dispatch('app/setBrandInfo', res.data);
      }
    }).catch(() => ({}));
    const status = this.$route.query.status;
    // s0状态下, 重试次数为1, 重试间隔为1s
    if (status !== 's0') {
      this.pending = 16;
    }
    this.getOrderStatus();
    window.addEventListener('beforeunload', this.beforeUnloadEvent);
  },
  beforeDestroy() {
    this.sendGaEvent('exit_payment_result_page');
    this.sendRiskDeviceFingerPrint('exit_payment_result_page');
    window.removeEventListener('beforeunload', this.beforeUnloadEvent);
  },
  methods: {
    getOrderStatus() {
      this.tryCount += 1;
      getStatus(this.$route.query.key ? this.$route.query.key : this.$route.params.id).then(res => {
        if (res.respCode === '20000') {
          this.orderInfo = res.data;
          if (res.data.status === 'S') { // 成功
            this.resultPopup = {
              visible: true,
              popupStatus: 'success',
              popupTitle: this.$t('message.result.success'),
              popupText: `${this.$t('message.result.successPop')}`,
              redirectUrl: res.data.subscriptionManageUrl || res.data.redirectUrl,
              billingAddress: !res.data.hideBillingInformation ? res.data.billingAddress : '',
            };
            return;
          } else if (res.data.status === 'F') { // 失败
            if (res.data.retry === '1') {
              this.$router.push({
                path: '/aggregate',
                query: { key: this.$route.query.key },
              });
              return;
            }
            this.resultPopup = {
              visible: true,
              popupStatus: 'failed',
              popupTitle: this.$t('message.result.failed'),
              popupText: `${this.$t('message.result.reason')}: ${res.data?.message || res.respMsg || ''}`,
              redirectUrl: res.data.redirectUrl,
            };
            return;
          } else if (res.data.status === 'P' || res.data.status === 'R') { // 等待/重定向
            if (this.tryCount < this.pending) { // 重试
              setTimeout(() => {
                this.getOrderStatus();
              }, this.tryInterval);
            } else {
              if (res.data.status === 'P' || !res.data.redirectUrl) {
                this.resultPopup = {
                  visible: true,
                  popupStatus: 'failed',
                  popupTitle: this.$t('message.result.unknow'),
                  popupText: this.$t('message.result.unknowTip'),
                  showReturnBtn: false,
                  redirectUrl: res.data.redirectUrl,
                };
                return;
              } else {
                this.resultPopup = {
                  visible: true,
                  popupStatus: 'failed',
                  popupTitle: this.$t('message.result.unknow'),
                  popupText: this.$t('message.result.unknowTip'),
                  redirectUrl: res.data.redirectUrl,
                };
                return;
              }
            }
          } else {
            this.resultPopup = {
              visible: true,
              popupStatus: 'failed',
              popupTitle: this.$t('message.result.unknow'),
              popupText: this.$t('message.result.unknowTip'),
              redirectUrl: res.data.redirectUrl,
            };
            return;
          }
        } else {
          if (res.data.retry === '1') {
            this.$router.push({
              path: '/aggregate',
              query: { key: this.$route.query.key },
            });
            return;
          }
          // 超时订单处理
          if (res.respCode === '00020|50054' || res.respCode === '50054') {
            if (this.tryCount < this.pending) {
              setTimeout(() => {
                this.getOrderStatus();
              }, this.tryInterval);
            } else {
              this.resultPopup = {
                visible: true,
                popupStatus: 'failed',
                popupTitle: this.$t('message.result.unknow'),
                popupText: this.$t('message.result.unknowTip'),
                showReturnBtn: false,
                redirectUrl: res.data.redirectUrl,
              };
              return;
            }
            return;
          }
          if (exceptionShow(res.respCode, this.$router, this.$route.query.key ? this.$route.query.key : this.$route.params.id, this.type)) {
            return;
          }
          this.resultPopup = {
            visible: true,
            popupStatus: 'failed',
            popupTitle: this.$t('message.result.failed'),
            // TODO 多语言？
            popupText: '',
            redirectUrl: res.data.redirectUrl,
          };
          return;
        }
        if (this.tryCount === 1) {
          this.sendGaEvent('visit_payment_result_page');
          this.sendRiskDeviceFingerPrint('visit_payment_result_page');
        }
      }).catch(() => {
        if (this.tryCount === 1) {
          this.sendGaEvent('visit_payment_result_page');
          this.sendRiskDeviceFingerPrint('visit_payment_result_page');
        }
        if (this.tryCount < this.pending) { // 重试
          setTimeout(() => {
            this.getOrderStatus();
          }, this.tryInterval);
        } else {
          this.resultPopup = {
            visible: true,
            popupStatus: 'failed',
            popupTitle: this.$t('message.result.unknow'),
            popupText: this.$t('message.result.unknowTip'),
            showReturnBtn: false,
          };
        }
      });
    },
    sendGaEvent(eventName) {
      sendGaResultEvent(this.$route.query.type, this.$route.query.key, this.orderInfo, eventName);
    },
    beforeUnloadEvent() {
      this.sendGaEvent('exit_payment_result_page');
      this.sendRiskDeviceFingerPrint('exit_payment_result_page');
    },
    sendRiskDeviceFingerPrint(event) {
      const param = {
        m: this.$route.query.merchantTxnId || '',
        e: event,
      };
      deviceFingerprintManager.send(param);
    },
    onCancel() {
      const { orderInfo } = this;
      // 如果是允许重试订单，则返回重新支付
      if (orderInfo.retry === '1') {
        this.$router.push({
          path: '/aggregate',
          query: { key: this.$route.query.key },
        });
      }
      if (orderInfo.redirectUrl) {
        window.location.href = orderInfo.redirectUrl;
      }
    },
    onSuccess() {
      const { orderInfo } = this;
      // 如果是订阅托管页面的换卡 跳转到托管页面
      if (orderInfo.subscriptionManageUrl) {
        const url = orderInfo.subscriptionManageUrl || '';
        if (url) {
          window.location.href = url;
        }
      }
    },
  },
};
</script>
<style lang="scss">
.layout-wrapper {
  height: 100vh;
  position: relative;

}

.header-wrapper {
  display: none;
}

.footer-box {
  display: none;
}

.content-wrapper {
  height: 100vh;
  padding-top: 0 !important;

}
</style>
<style scoped lang="scss">
.process-box {
  position: relative;
  display: inline-block;

  .process-item {
    animation: 1.5s linear 0s normal none infinite rotate;
  }

  .wallet {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .custom_loading {
    font-size: 32px;
    color: #182058;
  }
}

.ellipsis {
  position: absolute;
}

.pending-wrappe {
  position: relative;
  width: 100%;
  height: 100%;
}

.result-box {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding-top: 0 !important;

  .pending {
    margin-top: 6px;
    color: #182058;
  }
}
</style>
